<!-- Language toggle button: shows the target (next) language -->
<button
  type="button"
  class="lang-toggle-btn"
  [attr.aria-label]="switchLabelKey | translate"
  [attr.title]="switchLabelKey | translate"
  (click)="toggleLanguage()"
>
  <!-- Decorative: the button's aria-label already names the action, and the visible text is just the code. -->
  <img [src]="nextLang.flag" class="wd-20" alt="" aria-hidden="true" />
  <span class="lang-toggle-label" [class]="nextLang.class">{{ nextLang.name }}</span>
</button>

<!-- 
<div class="nav-item" ngbDropdown #languageRef="ngbDropdown">
  <a class="nav-link" ngbDropdownToggle id="languageDropdown" role="button">
    <img [src]="selectedLang.flag" class="wd-20 me-1" [attr.title]="selectedLang.name" [attr.alt]="selectedLang.name" />
    <span class="fw-bold ms-1 me-1 d-none d-md-inline-block" [class]="selectedLang.class">{{ selectedLang.name }}</span>
  </a>
  <div ngbDropdownMenu aria-labelledby="languageDropdown" class="languageDropdown">
    <a ngbDropdownItem class="py-2" *ngFor="let lang of languages" (click)="changeCurrentLang(lang)" role="button">
      <img [src]="lang['info']['flag']" class="wd-20 me-1" [attr.title]="lang['info']['name']"
        [attr.alt]="lang['info']['name']" />
      <span class="wd-20 me-1" [class]="lang['info']['class']"> {{ lang['info']['name'] }} </span></a>
  </div>
</div>
-->
